import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[autosizeInput]'
})
export class AutosizeInputDirective {
    testEl;

    @HostListener('keydown', ['$event'])
    @HostListener('input', ['$event']) 
    onInput(e) {
        if( !this.testEl ) {
            return;
        }
        this.testEl.innerText = e.target.value;
        this.setWidth();
    }

    constructor(private elem: ElementRef) {
        elem.nativeElement.className += ' autosize';
        this.createTestElement();
    }
    setWidth() {
        if( !this.testEl ) {
            return;
        }
        let width = this.testEl.offsetWidth + 15;
        if( width < 20 ) {
            width = 20;
        }
        this.elem.nativeElement.style = 'width: ' + width + 'px';
    }
    createTestElement() {
        let el = this.elem.nativeElement;
        let span = document.createElement('span');
        span.setAttribute('style', 'visibility: hidden; opacity: 0; white-space: nowrap; position: absolute; pointer-events: none; display: block; z-index: -1; font-weight: inherit');
        this.testEl = span;
        el.parentElement.appendChild(span);
        setTimeout(() => {
            this.testEl.innerHTML = el.value.replace(' ', '&nbsp;');
            this.setWidth();
        }, 200);
    }
}